import type { EffectiveAccess } from '@/api/appAccess';

export function configuredPathAccess(access: EffectiveAccess, pathname: string): boolean {
  const path = pathname.trim().toLowerCase().replace(/\/+$/, '') || '/';
  // Match the most specific registered tab. Segment boundaries prevent /atbs-x
  // from inheriting /atbs, and child restrictions override parent grants.
  const resource = access.resources
    .filter((item) => item.path && (path === item.path || (item.path !== '/' && path.startsWith(`${item.path}/`))))
    .sort((a, b) => b.path!.length - a.path!.length)[0];
  return Boolean(resource && access.allowed[resource.key]);
}
